import { ManagedCarousel as j } from "./managedCarousel-Bu1k7zH3.mjs.js";
import { e as C, d as k, a as y, P as R } from "./useProductCardClick-zexHJZhw.mjs.js";
import { j as a, R as N } from "./client-BkmPNNjT.mjs.js";
import { c as w } from "./x-BeA-aqru.mjs.js";
const v = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], b = w("loader-circle", v), E = ({
  podId: r,
  heading: c,
  headingTag: d = "h2",
  cioOptions: m,
  carouselProps: l,
  config: n,
  apiKey: p,
  version: u
}) => {
  const i = {
    apiKey: p,
    version: u
  }, {
    data: s,
    isLoading: h
  } = C(i, r, m), x = k("md"), {
    handleRecommendationsClick: f
  } = y(i), g = (e, t, o) => {
    f(t, o, {
      pod_id: r,
      response: s?.response,
      result_id: s?.result_id
    });
  };
  return h || !s ? /* @__PURE__ */ a.jsx("div", {
    className: "flex items-center justify-center p-8",
    children: /* @__PURE__ */ a.jsx(b, {
      className: "size-8 bg-white animate-spin"
    })
  }) : s.response.total_num_results ? /* @__PURE__ */ a.jsxs("div", {
    children: [N.createElement(d, {
      className: "text-lg leading-7 md:text-2xl font-medium mb-4 text-gray-700"
    }, c ?? s?.response.pod?.display_name ?? "Recommendations"), /* @__PURE__ */ a.jsx(j, {
      ...l,
      children: s.response.results?.filter((e) => e.data).map((e, t) => /* @__PURE__ */ a.jsx(R, {
        showMfg: n?.show_manufacturer,
        showRating: n?.show_rating,
        lazyLoadImage: x ? t > 5 : t > 2,
        onClick: (o, _) => g(o, _, t),
        css: {
          root: "p-4 m-2 mb-3 hover:shadow-custom",
          price: "leading-tight",
          imageWrapper: "h-40",
          contentWrapper: "[&_a]:leading-5 [&_a]:text-sm"
        },
        data: {
          name: e.value || "",
          id: e.data?.id || "",
          ...e.data
        }
      }, e.itemId))
    })]
  }) : /* @__PURE__ */ a.jsx("div", {
    className: "flex items-center justify-center p-8",
    children: /* @__PURE__ */ a.jsx("p", {
      className: "text-gray-500",
      children: "No recommendations found"
    })
  });
};
export {
  E as CioRecommendations
};
